window.addEventListener('DOMContentLoaded', function () {
  function handleRegisterForm(count) {
    if (count > 20) return;

    if (typeof $ === 'undefined') {
      return setTimeout(() => handleRegisterForm(count + 1), 300);
    }

    $('#WhatBringsYouHere').on('change', function () {
      if (this.value === 'expecting' || this.value === 'parent') {
        $("#BabyBirthdayWrapper").removeClass('d-none');
        $('#BabyBirthday').attr('required', '');
      } else if (this.value === 'gifting' || this.value === 'preconception') {
        $("#BabyBirthdayWrapper").addClass('d-none');
        $('#BabyBirthday').removeAttr('required');
      }
    }).trigger("change");
  
    $(document).on('submit', '#create_customer', function (event) {
  
      var $tagsInput = $('.register-container [name="customer[tags]"]');
      var whatBringsYouHere = $('#WhatBringsYouHere').val();
      var babyBirthday = $('#BabyBirthday').val();
      var dateEntered = new Date(babyBirthday);
      var dateChanged = ('0' + dateEntered.getDate()).slice(-2) + '/'
        + ('0' + (dateEntered.getMonth() + 1)).slice(-2) + '/'
        + dateEntered.getFullYear();
  
      var tags = [$tagsInput.val()]
      if (whatBringsYouHere) {
        tags.push('what_brings_you_here:' + whatBringsYouHere)
      }
      if (babyBirthday) {
        tags.push('baby_birthday:' + dateChanged)
      }
      const registrationStore = sessionStorage.getItem('registrationStore');
      if (registrationStore) {
        tags.push(`${registrationStore}_signup`);
      }
  
      $tagsInput.val(tags.join(','))
    });
  
    var currentURL = window.location.href;
    if (currentURL.indexOf("?return_url=/apps/giftregistry/create") > 1) {
      $(document).on('submit', '#create_customer', function () {
        localStorage.setItem('redirectToRegistry', 'true');
      });
    } else {
      $('#customer_tags').val('newsletter');
    }
  }

  handleRegisterForm(0)
});